import { KnownInstrumentationEvents } from '@office-start/instrumentation-types';
import { convertTitleAcquisitionToAppDefinition, } from '@office-start/metaos-hub-sdk';
import { logError } from '@office-start/telemetry-service';
const isValidAppDefinition = (appDefinition) => {
    //TODO: more rules to validate pased data
    return !!(appDefinition === null || appDefinition === void 0 ? void 0 : appDefinition.id);
};
export const getHarmonyAppDefinitions = (acquisitions) => {
    const harmonyApps = [];
    if (acquisitions) {
        acquisitions.forEach((title) => {
            const successfullyParsedTitle = getHarmonyAppDefinition(title);
            if (successfullyParsedTitle !== undefined) {
                harmonyApps.push(successfullyParsedTitle);
            }
        });
    }
    return harmonyApps;
};
export const getHarmonyAppDefinition = (acquisition) => {
    let harmonyApp;
    if (acquisition) {
        try {
            harmonyApp = new MOSTitleAcquistion(acquisition);
        }
        catch (_a) {
            logError({
                eventName: KnownInstrumentationEvents.M365AppsDefinitionError,
                errorType: 'M365_MOS3_Title_Definition_Parsing_Error',
                message: `${acquisition.appId}'s definition failed to parse`,
            });
        }
    }
    return isValidAppDefinition(harmonyApp) ? harmonyApp : undefined;
};
// TODO: considering moving this utility into m364-apps-service when refactoring to call MOS3 API directly from client.
export class MOSTitleAcquistion {
    constructor(appDefinition) {
        var _a, _b, _c, _d, _e, _f;
        appDefinition.titleDefinition.devicePermissions =
            (_b = (_a = appDefinition.titleDefinition.devicePermissions) === null || _a === void 0 ? void 0 : _a.map((_) => _.toLowerCase())) !== null && _b !== void 0 ? _b : [];
        this._appDefinition = appDefinition;
        this.id = appDefinition.appId || '';
        this.smallImageUrl = appDefinition.titleDefinition.iconSmall.uri || '';
        this.largeImageUrl = appDefinition.titleDefinition.iconLarge.uri || '';
        this.monoLineImageUrl =
            ((_c = appDefinition.titleDefinition.monoLineIcon) === null || _c === void 0 ? void 0 : _c.uri) || undefined;
        this.name = appDefinition.titleDefinition.name;
        this.accentColor = appDefinition.titleDefinition.accentColor || '';
        this.developerName = appDefinition.titleDefinition.developerName || '';
        this.staticTabs =
            appDefinition.titleDefinition.elementDefinitions.staticTabs || [];
        this.shortDescription =
            appDefinition.titleDefinition.shortDescription || '';
        this.isFullScreen = appDefinition.titleDefinition.isFullScreen || false;
        this.showLoadingIndicator =
            appDefinition.titleDefinition.showLoadingIndicator || false;
        this.hubSdkAppDefinition = convertTitleAcquisitionToAppDefinition(this._appDefinition);
        this.acquisitionState = (_d = appDefinition.acquisitionState) !== null && _d !== void 0 ? _d : 'Acquired';
        this.canBeUnacquired = (_e = appDefinition.canBeUnacquired) !== null && _e !== void 0 ? _e : false;
        this.devicePermissions =
            (_f = appDefinition.titleDefinition.devicePermissions) !== null && _f !== void 0 ? _f : [];
        this.actions = appDefinition.titleDefinition.elementDefinitions.actions
            ? appDefinition.titleDefinition.elementDefinitions.actions
            : undefined;
        this.acquisitionDate = appDefinition.titleDefinition.acquisitionDate;
        this.acquisitionContext = appDefinition.acquisitionContext;
        this.supportedPlatformCommands =
            appDefinition.supportedPlatformCommands;
        this.validDomains = appDefinition.titleDefinition.validDomains;
        this.composeExtensions =
            appDefinition.titleDefinition.elementDefinitions.composeExtensions;
        this.webApplicationInfo =
            appDefinition.titleDefinition.webApplicationInfo;
    }
}
//# sourceMappingURL=MOSAppDefinitionWrapper.js.map